import type { FC } from 'react';

import { Col, Text } from '@opendoor/bricks-next';
import { TextButton } from 'platform/bricks-next';
import { useAuthContext } from 'platform/components/AuthContext';
import { List } from 'shared/components/List';
import { ListItem } from 'shared/components/ListItem';
import { GenericErrorPage } from 'shared/routes/errors/GenericErrorPage';

/** Page to show when user it not authorized. */
export const NotAuthorizedPage: FC = () => {
  const { logout } = useAuthContext();
  return (
    <GenericErrorPage
      reason="not-authorized"
      causedBy="user-error"
      headerContent="You don’t have permission to view this page"
    >
      <Col pt="$10x" gap="$4x">
        <Text tag="p" typography="$bodyMedium" $platform-web={{ fontWeight: 700 }} textAlign="left">
          How can I resolve this?
        </Text>
        <List pl="$12x" variant="bullet">
          <ListItem>
            <TextButton
              data-testid="sign-out"
              display="inline"
              analyticsName="account-redirect"
              onClick={() => void logout()}
              label="Sign out"
              size="small"
              variant="secondary"
            />{' '}
            and try signing into a different account
          </ListItem>
          <ListItem>If someone added you, contact the owner to get access</ListItem>
        </List>
      </Col>
    </GenericErrorPage>
  );
};
